import _ from 'lodash';
import resolveResponsiveValue from './ResponsiveValueResolver';
export default function resolveDefinitionValue(theme, screenWidth, definitions, definitionValue) {
    var value;
    if (isCustomValue(definitionValue)) {
        value = definitionValue.custom;
    }
    else {
        value = definitions;
    }
    if (!_.isArray(value)) {
        return value;
    }
    return resolveResponsiveValue(theme, screenWidth, value);
}
function isCustomValue(value) {
    return _.isObject(value);
}
//# sourceMappingURL=DefinitionResolver.js.map